module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var hideProperties = (factoryKey==='control_bullet_text' || factoryKey==='control_multiple_text_input' || factoryKey==='control_text_input')? 'display:none;':'';
   var useTextArea = factoryKey!=='control_text_input'? '': 'display:none';
   var useInputText = factoryKey!=='control_text_input'? 'display:none': '';
   var u = require('util/TextUtil.js').default;
   var newText = text;
   newText=(isHtml.toString()==='true' ? (newText) : u.htmlEncode(newText));

    ; __append("\r\n<div>\r\n    <div class=\"col-xs-12 propDetail row\" style=\"padding-right: 0px; ")
    ; __append(escapeFn(hideProperties ))
    ; __append("\" >\r\n        <div id=\"propTextAlignment\" class=\"col-xs-7 col-md-7 nopadding ")
    ; __append(escapeFn(hideAlignment))
    ; __append("\">\r\n            <img id=\"align-left\" name=\"align-left\" src=\"")
    ; __append( require('editor/icons/align_left.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( alignLeftSelection ))
    ; __append("\" />\r\n            <img id=\"align-center\" name=\"align-center\" src=\"")
    ; __append( require('editor/icons/align_center.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignCenterSelection ))
    ; __append("\" />\r\n            <img id=\"align-right\" name=\"align-right\" src=\"")
    ; __append( require('editor/icons/align_right.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( alignRightSelection ))
    ; __append("\" />\r\n        </div>\r\n        <div id=\"propTextHTML\" class=\"col-xs-4 col-md-4 nopadding ")
    ; __append(escapeFn(hideAlignment))
    ; __append("\">\r\n            <input type=\"checkbox\" name=\"isHtml\"  />\r\n            <label class=\"new-font-size\">HTML</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 propDetail nopadding\" style=\"")
    ; __append(escapeFn( useTextArea))
    ; __append("\">\r\n        <div id=\"propTextTitle\" class=\"col-xs-2 nopadding prop-sublabel new-font-size\" style=\"margin-right: 5px; float:left;\">Text</div>\r\n        <textarea id=\"textMultiline\" name=\"text\" type=\"text\" class=\"new-font-size ")
    ; __append(escapeFn( text !== '' ? 'translatable' : '' ))
    ; __append("\" data-attr=\"text\" style=\" height: 60px; width: 100% \">")
    ; __append(escapeFn( text ))
    ; __append("</textarea>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 propDetail nopadding\" style=\"")
    ; __append(escapeFn( useInputText))
    ; __append("\">\r\n        ")
    ; if(factoryKey === 'control_text_input'){
    ; __append("\r\n            <div id=\"propTextTitle\" class=\"col-xs-2 nopadding-l prop-sublabel\" style=\"float:left;\">Text</div>\r\n        ")
    ; }
    ; __append("\r\n        <div class=\"col-xs-10 nopadding-r\">\r\n            <input type=\"text\" name=\"text\" value=\"")
    ; __append(escapeFn( text ))
    ; __append("\" />\r\n        </div>\r\n\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}